import * as Yup from "yup";

export const validationSchema = function (
  contactMethodName,
  contactMethodInputName
) {
  const yupObject = {};
  yupObject[contactMethodName] = Yup.string()
    .nullable()
    .required("Contact Information is required.");
  yupObject[contactMethodInputName] = Yup.string().when(contactMethodName, {
    is: "Email",
    then: Yup.string()
      .email("Please enter a valid email.")
      .nullable()
      .required("Email is required."),
    otherwise: Yup.string()
      .nullable()
      .required("Please provide further contact details"),
  });

  return Yup.object().shape(yupObject);
};

export const initialValues = function (
  contactMethodName,
  contactMethodInputName
) {
  const initValuesObj = {};
  initValuesObj[contactMethodName] = "";
  initValuesObj[contactMethodInputName] = "";
  return initValuesObj;
};
